export enum LocalStorageKeys {
    Visitor = 'visitor',
    Cart = 'cart',
    LastCartUpdate = 'lastCartUpdate',
    CartDiscountCode = 'cartDiscountCode',
}